import { Users, Building2, PawPrint, Store, AlertTriangle, CreditCard, BadgeCheck, Landmark } from "lucide-react";
import { StatCard } from "./StatCard";

export const OverviewTab = ({ stats, onReviewShelters }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <StatCard title="Total Users" value={stats.users.total} subtitle={`${stats.users.active} active · +${stats.users.new_this_week} this week`} icon={Users} />
      <StatCard title="Activated Breeders" value={stats.breeders.activated || 0} subtitle={`${stats.breeders.founding_members || 0} founding members`} icon={BadgeCheck} />
      <StatCard title="Activation Revenue" value={`$${Number(stats.payments?.activation_revenue || 0).toFixed(2)}`} subtitle={`${stats.payments?.activation_payments || 0} successful activations`} icon={CreditCard} />
      <StatCard title="Payout Ready" value={stats.payments?.payouts_ready || 0} subtitle={`${stats.payments?.payout_onboarding || 0} onboarding`} icon={Landmark} />
      <StatCard title="Breeders" value={stats.breeders.total} subtitle={`${stats.breeders.founding_spots_remaining ?? 50} founding spots left`} icon={PawPrint} />
      <StatCard title="Shelters" value={stats.shelters.total} subtitle={`${stats.shelters.pending} pending`} icon={Building2} alert={stats.shelters.pending > 0} />
      <StatCard title="Listings" value={stats.listings.total} subtitle={`${stats.listings.active} active`} icon={Store} />
      <StatCard title="Suspended" value={stats.users.suspended || 0} subtitle="User accounts" icon={AlertTriangle} alert={stats.users.suspended > 0} />
    </div>

    {(stats.shelters.pending > 0 || stats.moderation.total_open_reports > 0) && (
      <div className="glass-card p-4 border-[#D4AF37]/30">
        <div className="flex items-center gap-2 mb-2">
          <AlertTriangle className="w-5 h-5 text-[#D4AF37]" />
          <h3 className="text-[#EDEDED] font-medium">Pending Actions</h3>
        </div>
        <p className="text-[#A1A1AA] text-sm">
          {stats.shelters.pending} shelter verifications · {stats.moderation.total_open_reports} open reports
        </p>
        {stats.shelters.pending > 0 && (
          <button onClick={onReviewShelters} className="mt-3 px-4 py-2 bg-[#D4AF37] text-black text-sm rounded-lg hover:bg-[#B8962E] transition-colors">
            Review Shelters
          </button>
        )}
      </div>
    )}

    <div className="glass-card p-6">
      <h3 className="text-[#EDEDED] font-medium mb-4">Subscription Tiers</h3>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {Object.entries(stats.breeders.by_tier).map(([tier, count]) => (
          <div key={tier} className="p-3 rounded-lg bg-[#18181B]">
            <p className="text-2xl text-[#EDEDED]">{count}</p>
            <p className="text-sm text-[#71717A] capitalize">{tier}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
